import { createAsyncThunk } from "@reduxjs/toolkit";
import { Config } from "../../config";
import { axiosConfig } from "../../utils/util.fns";
import axios from "axios";
import {
	createQuestionTypeAndWeightageType,
	updateQuestionTypeAndWeightageType,
} from "../../containers/settings/modal";

export const getAllQueTypeAndWeightage = createAsyncThunk("questionTypeAndWeightage/all", async () => {
	const response = await axios.get(Config.apiSecureUrl + "/question-types", axiosConfig());
	return response.data;
});

export const questionTypeAndWeightageCreate = createAsyncThunk(
	"questionTypeAndWeightage/create",
	async (payload: createQuestionTypeAndWeightageType) => {
		const response = await axios.post(Config.apiSecureUrl + "/question-types", payload, axiosConfig());
		return response.data;
	}
);
export const delQueTypeAndWeightage = createAsyncThunk("questionTypeAndWeightage/delete", async (id: number | null) => {
	const response = await axios.delete(Config.apiSecureUrl + `/question-types/${id}`, axiosConfig());
	return response.data;
});
export const updateQueTypeAndWeightage = createAsyncThunk(
	"questionTypeAndWeightage/update",
	async (payload: updateQuestionTypeAndWeightageType) => {
		const response = await axios.put(Config.apiSecureUrl + `/question-types/${payload.id}`, payload.obj, axiosConfig());
		return response.data;
	}
);
// export const getLink = createAsyncThunk("get/link", async () => {
// 	const response = await axios.get(Config.apiSecureUrl + "/exam/token", axiosConfig());
// 	return response.data;
// });
